module.exports = __webpack_public_path__ + "img/39.6c196a7c.jpg";